import {
    ChangeDetectionStrategy,
    Component,
    CUSTOM_ELEMENTS_SCHEMA,
    inject,
    Signal,
    signal,
    WritableSignal
} from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { OpenRequestTab, OpenRequestTabsService } from '../../services/open-request-tabs.service';
import { select } from '@ngxs/store';
import { UserState } from '@shs-digi-care-monorepo/frontend-lib';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, RouterLinkActive, TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SidebarComponent {
    private readonly router = inject(Router);
    private readonly openRequestTabs = inject(OpenRequestTabsService);

    protected readonly tabs: Signal<OpenRequestTab[]> = this.openRequestTabs.tabs;
    protected readonly activeTabId: Signal<string | null> = this.openRequestTabs.activeId;
    protected readonly isAdmin: Signal<boolean> = select(UserState.isAdmin);
    protected readonly collapsed: WritableSignal<boolean> = signal(true);

    /** Updates the collapsed state whenever the user toggles the sidebar. */
    protected onCollapsedChanged(event: Event): void {
        this.collapsed.set((event as CustomEvent<boolean>).detail);
    }

    /** Activates a previously opened request tab and navigates to the request overview. */
    protected openTab(id: string): void {
        this.openRequestTabs.setActive(id);
        this.router.navigate(['/requests'], { queryParams: { tab: id } });
    }

    /** Closes an opened request tab without navigating. */
    protected closeTab(id: string, event: Event): void {
        event.stopPropagation();
        this.openRequestTabs.close(id);
    }
}
